import dayjs from 'dayjs';

import { ActivityFeedFilter, ActivityFeedItem, FilterOption } from '@/types/activityFeed';

export enum FilterCategory {
  REPORTS = 'Reports',
  CLINICAL_NOTES = 'Clinical Notes',
  CALLS = 'Calls',
  SUPPORT_MESSAGES = 'Support Messages',
  PATIENT_STATUS = 'Patient Status',
  POST_GRID_LETTERS = 'Postgrid'
}

export const DEFAULT_FILTER_OPTIONS: Record<string, FilterOption[]> = {
  [FilterCategory.REPORTS]: [
    { id: ActivityFeedFilter.RED, label: 'Red Alert', checked: true },
    { id: ActivityFeedFilter.YELLOW, label: 'Yellow Alert', checked: true },
    { id: ActivityFeedFilter.REMOTE, label: 'Routine (Remote)', checked: true },
    { id: ActivityFeedFilter.IN_CLINIC, label: 'Routine (In-Clinic)', checked: true }
  ],
  [FilterCategory.CLINICAL_NOTES]: [
    { id: ActivityFeedFilter.CLINICAL_NOTES, label: 'Clinical Note', checked: true }
  ],
  [FilterCategory.CALLS]: [
    { id: ActivityFeedFilter.OUTBOUND, label: 'Outbound Call', checked: true },
    { id: ActivityFeedFilter.INBOUND, label: 'Inbound Call', checked: true }
  ],
  [FilterCategory.PATIENT_STATUS]: [
    { id: ActivityFeedFilter.PATIENT_STATUS, label: 'Patient Status', checked: true }
  ],
  [FilterCategory.POST_GRID_LETTERS]: [
    { id: ActivityFeedFilter.POST_GRID_LETTERS, label: 'Postgrid', checked: true }
  ]
  // [FilterCategory.SUPPORT_MESSAGES]: [
  //   { id: ActivityFeedFilter.SUPPORT_MESSAGE, label: 'Support Message', checked: false }
  // ]
};

export const formatTimeDate = (date: string | Date, format: string = 'MM/DD/YY') => {
  if (!date) return '';
  const dateStr = typeof date === 'string' ? date : date.toISOString();
  let parsedDate = dayjs(date);

  // If date is invalid, extracting first 8 characters and creating a new Date
  if (!parsedDate.isValid() && typeof dateStr === 'string' && dateStr.length >= 8) {
    const extractedDate = dateStr.substring(0, 8);
    const formattedDate = `${extractedDate.substring(0, 4)}-${extractedDate.substring(4, 6)}-${extractedDate.substring(6, 8)}`;
    parsedDate = dayjs(formattedDate, 'YY-MM-DD');
  }

  if (!parsedDate.isValid()) return '';

  const datePart = parsedDate.format(format);
  const timePart = parsedDate.format('hh:mm A');

  return {
    date: datePart,
    time: timePart
  };
};

export const formatCallDuration = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  if (hours > 0) {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const groupActivitiesByDate = (activities: ActivityFeedItem[]) => {
  if (!activities || activities.length === 0) return {};

  const today = dayjs().startOf('day');
  const yesterday = today.subtract(1, 'day');

  const groups: Record<string, ActivityFeedItem[]> = {
    TODAY: [],
    YESTERDAY: []
  };

  activities.forEach((activity) => {
    const activityDate = dayjs(activity.eventDate).startOf('day');

    if (activityDate.isSame(today)) {
      groups['TODAY'].push(activity);
    } else if (activityDate.isSame(yesterday)) {
      groups['YESTERDAY'].push(activity);
    } else {
      const dateStr = activityDate.format('M/D/YYYY');
      if (!groups[dateStr]) {
        groups[dateStr] = [];
      }
      groups[dateStr].push(activity);
    }
  });

  // Remove empty groups
  Object.keys(groups).forEach((key) => {
    if (groups[key].length === 0) {
      delete groups[key];
    }
  });

  return groups;
};
